
<template>
  <div id="agSubstringFormatter" v-if="formatter.config">
    <div class="agInputGroup agInputGroupCentered">
      <div class="agInputGroup agInputGroupInline">
        <label>Start Index:</label>
        <b-input
          class="agSmallInput"
          v-model="formatter.config.start"
          type="number"
          min="0"
          step="1"
          :disabled="disableUI"
          @keyup.native="setPreview"
          @change="setPreview"
        ></b-input>
      </div>
      <div class="agInputGroup agInputGroupInline">
        <label>Length:</label>
        <b-input
          class="agSmallInput"
          v-model="formatter.config.length"
          type="number"
          min="0"
          step="1"
          :disabled="disableUI"
          @keyup.native="setPreview"
          @change="setPreview"
        ></b-input>
      </div>
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Test String:</label>
      <b-input
        class="agExtraLargeInput"
        v-model="testString"
        placeholder="e.g. Orobytes Flows"
        autocomplete="false"
        :disabled="disableUI"
        @keyup.native="setPreview"
      ></b-input>
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Preview: {{ preview }}</label>
    </div>
  </div>
</template>



<script>
// components

// modules

export default {
  name: "ag-substringFormatter",
  components: {},
  props: {
    disableUI: Boolean,
    formatter: Object,
  },
  data() {
    return {
      testString: "",
      preview: "",
    };
  },
  computed: {},
  watch: {},

  created() {},

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

    // emitted Events

    // other

    reset() {
      this.setPreview();
    },

    prepareForSave() {},

    setPreview() {
      this.preview = "";
      var sStart;
      var sLength;
      if (this.testString && this.formatter.config.start) {
        sStart = Number(this.formatter.config.start);
        if (this.formatter.config.length) {
          sLength = Number(this.formatter.config.length);
          if (sStart >= 0) {
            if (sLength >= 0) {
              this.preview = this.testString.substr(sStart, sLength);
            } else {
              this.preview = this.testString.substring(
                sStart + sLength,
                sStart
              );
            }
          } else {
            if (sLength < 0) {
              let sInd = this.testString.length + sStart;
              let sOffset = sInd + sLength;
              this.preview = this.testString.substring(sOffset, sInd);
            } else {
              this.preview = this.testString.substr(sStart, sLength);
            }
          }
        } else {
          this.preview = this.testString.substr(sStart);
        }
      }
      return this.preview;
    },
  },
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/SubstringFormatter.vue